import { Country } from '~/Api/Country';
import { RawDataSource } from '~/Api/DataSource';
import DataSource from '~/Api/Product/History/DataSource';
import ProductHistoryProduct from '~/Api/Product/History/ProductHistoryProduct';

export interface RawProductHistoryProduct {
	id: string;
	name?: string;
	dataSource?: RawDataSource;
}

export const mapProductHistoryProduct = (product: RawProductHistoryProduct) =>
	new ProductHistoryProduct(
		product.id,
		product.name ?? null,
		product.dataSource !== undefined
			? new DataSource(
					product.dataSource.type,
					new Country(product.dataSource.country.alpha2, product.dataSource.country.name),
					product.dataSource.shortName,
					product.dataSource.description
			  )
			: null
	);
